import { get, post } from "@shared/core/io";
import { afterGateway } from "@shared/apis/gw-helper";

const PRODUCT_V1_API_PREFIX = "/gw/cprod/api/v1";

export function searchProduct(data) {
  return post(`${PRODUCT_V1_API_PREFIX}/searchProduct/search`, data);
}

export function getCityLandmarkAndAreaOfCity(cityId) {
  return get(`${PRODUCT_V1_API_PREFIX}/gis/landmarkAndAreaOfCity/${cityId}`);
}

export function getCitySearchHotWord(cityId) {
  return get(`${PRODUCT_V1_API_PREFIX}/searchProduct/hotWord/${cityId}`);
}

// { prefix: "", cityId: 350200 }
export function getCitySearchSuggest(data) {
  return post(`${PRODUCT_V1_API_PREFIX}/searchProduct/suggest`, data);
}

export function getComments(data) {
  const { productId, pageNow, pageSize } = data;
  return get(`/gw/ugc/api/v1/product/comments?productId=${productId}&pageNow=${pageNow}&pageSize=${pageSize}`);
}

export function getCommentsUserReceived(data) {
  const { userId, pageNow, pageSize } = data;
  return get(`/gw/ugc/api/v1/user/comments?userId=${userId}&pageNow=${pageNow}&pageSize=${pageSize}`);
}

export function getProductCalendar(productId) {
  return post(`${PRODUCT_V1_API_PREFIX}/calendar/query`, {
    productId,
  });
}

export function getProductDetail(data) {
  return post(`${PRODUCT_V1_API_PREFIX}/product/info`, data);
}

export function getRecommend(data) {
  return post(`${PRODUCT_V1_API_PREFIX}/homepage/recommend`, data);
}

export function queryHolidays(data /* {startDate, endDate} */) {
  return post(`${PRODUCT_V1_API_PREFIX}/calendar/holidays`, data);
}
export function getHolidaysByYear(year) {
  const actualKey = (year || new Date().getFullYear()).toString();
  return get(`${PRODUCT_V1_API_PREFIX}/product/holidays/${actualKey}`);
}

export function getQuickCondition(cityId) {
  return afterGateway(get(`${PRODUCT_V1_API_PREFIX}/searchProduct/quick-condition/${cityId}`));
}

export default {
  searchProduct,
  getCityLandmarkAndAreaOfCity,
  getCitySearchHotWord,
  getCitySearchSuggest,
  getComments,
  getProductCalendar,
  getProductDetail,
  getRecommend,
};
